import { useEffect, useLayoutEffect, useState, useRef} from "react";
import { connect, useStore } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import useMedia from "use-media";
import commonUtil from "../../common/commonUtil";
import { apiKeyCheck, versionGetApi, golfReserveChk } from "../../const";
import common from '../../resources/js/common/common';
import { Button } from "../atoms/button";
import { Label } from '../atoms/label';
import './../../resources/css/reservationConfirm/reservationConfirm.css';
import { GolfFooterContainer } from "./golfFooterContainer";
import { PullDownOptionForm } from "../molecules/pullDownOptionForm";
import '../../resources/css/reserveChk/reserveCheck.css'
import axios from "axios";
const GolfReservationCheckContainer = (props) => {
    const {
        kaiinken,
        setKaiinken,
        setGolfReservationCheck,
        setGolfReservationSearch,
        golfReservationSearch,
        setGolfReservationList,
        golfReservationList,
        location,
    } = props;

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);
    const [reserveSearchInfo, setReserveSearchInfo] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");

    const history = useHistory();
    const store = useStore();

    const processing = useRef(false);

    // プロパティ一覧
    const [successFlg, setSuccessFlg] = useState(false);

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if (Object.keys(state).length !== 0) {
            apiKey = state.apiKey;
        }
        if (apiKey === null) {
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
        if (apiKey) {
            common.doPost(apiKeyCheck, { apikey: apiKey }, afterApiKeyCheck);
        }
    })

    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }

    useEffect(() => {
        common.doPost(versionGetApi, {}, afterVerCheck);
        window.scroll({ top: 0, behavior: 'smooth' })
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
        
    }, [useMediaFlag]);

    useEffect(() => {
        //予約詳細確認画面以外からの遷移の場合は検索状態初期化
        let prevScreenInfo = store.getState().prevScreenInfo;
        if(prevScreenInfo && (prevScreenInfo.prevPath.indexOf("golf/reservationCheckDetail") === -1
             && prevScreenInfo.prevPath.indexOf("golf/reservationCheck") === -1)){
            setGolfReservationSearch({search:[],target:[]});
            setGolfReservationList([]);
            setGolfReservationCheck({});
            let searchPulldown = document.getElementById("reservationSearchPullDown");
            if(searchPulldown){
                searchPulldown.value = "0";
            }
        }

        //いつから年月日表示するか
        //上で更新された値を取得するにはstoreから値再取得する
        if(store.getState().golfReservationSearch.search.length === 0){
            setTargetDate();
        }
        if(store.getState().golfReservationList !== undefined && store.getState().golfReservationList.length !== 0){
            let targetDate = "";
            store.getState().golfReservationSearch.target.map((data) => {
                if(data.selected){
                    targetDate = data.target;
                }
            })
            search(targetDate);
        }
    },[])

    //検索期間選択プルダウンデータ作成
    const setTargetDate = (res) => {
        let oldYear = 2022;
        let date = new Date();
        let targetList = {
            search:[{id:0,value:"ご予約中",selected:true,valueYear:"ご予約中"}],
            target: golfReservationSearch.target
        }
        let dateList = [];
        let cnt = 1;
        for(let i = oldYear; i <= date.getFullYear(); i++){
            let obj = {
                id: cnt,
                value: "ご来場履歴(" + i.toString()+"年)",
                valueYear: i.toString(),
                selected: false
            }
            // targetList.search.push(obj);
            dateList.push(obj);
            cnt++;
        }
        dateList.sort((a, b) => b.valueYear - a.valueYear);
        targetList.search = targetList.search.concat(dateList);
        setGolfReservationSearch(targetList);
    }

    //対象期間変更時
    const changeTargetDate = (e) => {
        golfReservationSearch.search.map((data) => {
            if(e.target.value === data.id.toString()){
                data.selected = true;
            }else{
                data.selected = false;
            }
        })
        setGolfReservationSearch(golfReservationSearch);
    }

    //絞り込み日付データの選択
    const setSearchDate = (res) => {
        let targetDate = JSON.parse(JSON.stringify(golfReservationSearch));
        targetDate.target = [{id:0,value:"全期間",target:"全期間",selected:true}];
        let chkList = [];
        res.reservationList.map((data,index) => {
            let skipFlg = false;
            let date = data.date.slice(0,7);
            let dispDate = data.date.slice(0,4) + "年"+data.date.slice(5,7)+"月";
            let sortDate = parseInt(date.replace("-",""));
            let targetObj = {
                id:index + 1,
                value: dispDate,
                target: date,
                sort: sortDate,
                selected: false
            }
            chkList.map((chkData) => {
                if(chkData === date){
                    console.log("skip");
                    skipFlg = true;
                }
            })
            if(!skipFlg){
                targetDate.target.push(targetObj);
                chkList.push(date);
            }
        })
        let selectDate = "";
        golfReservationSearch.search.map((value) => {
            if(value.selected){
                selectDate = value.valueYear;
            }
        })
        //予約中なら昇順そうでなければ昇順
        if(selectDate === "ご予約中"){
            targetDate.target.sort((a, b) => a.sort - b.sort);
        }else{
            targetDate.target.sort((a, b) => b.sort - a.sort);
        }
        setGolfReservationSearch(targetDate);
        let selectDateArea = document.getElementById("selectDate");
        if(selectDateArea !== null && selectDateArea[0] !== null ){
            selectDateArea[0].selected = true;
        }
    }

    //検索期間変更時
    const changeSearchDate = (e) => {
        let targetDate = "";
        golfReservationSearch.target.map((data) => {
            if(e.target.value === data.id.toString()){
                data.selected = true;
                targetDate = data.target;
            }else{
                data.selected = false;
            }
        })
        setGolfReservationSearch(golfReservationSearch);
        search(targetDate);
    }

    const search = (targetDate) => {
        let reserveDateList = [];
        golfReservationList.map((reserveData) => {
            if(targetDate === "全期間"){
                reserveDateList.push(reserveData);
            }
            else if(reserveData.date.indexOf(targetDate) != -1){
                reserveDateList.push(reserveData);
            }
        })
        setReserveSearchInfo(reserveDateList);
    }

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }
    

    const onChangeKaiinkenName = (e) => {
        kaiinken.forEach((data) => {
            if (String(data.id) === e.target.value) {
                data.selected = true;
            } else {
                data.selected = false;
            }
        })
        setKaiinken(kaiinken);
    }

    const onClickSearch = () => {
        let contractNo = "";
        let facilityId = "";
        kaiinken.forEach((data) => {
            if(data.selected){
                contractNo = data.contractNo;
                facilityId = data.sisetuCd;
            }
        })
        let selectDate = "";
        golfReservationSearch.search.map((value) => {
            if(value.selected){
                selectDate = value.valueYear;
            }
        })
        let from;
        let to;
        //予約中の場合
        if(selectDate === "ご予約中"){
            let obj = {
                reservationMemNo:contractNo,
                golfCourseId:facilityId,
            }
            console.log(obj)
            common.doPost(golfReserveChk, obj, afterSearch);
        }else{      //過去予約の場合
            from = commonUtil.getStringFromDate(new Date(selectDate,0,1),"yyyy-MM-dd");
            let nowDate = new Date();
            //選択された年が現在の年だった場合は現在日時-1をセット
            if(selectDate.replace("年","") === nowDate.getFullYear().toString()){
                to = commonUtil.getStringFromDate(new Date(nowDate.getFullYear(),nowDate.getMonth(),nowDate.getDate() - 1),"yyyy-MM-dd");
            }else{
                to = commonUtil.getStringFromDate(new Date(selectDate,11,31),"yyyy-MM-dd");
            }
            let obj = {
                reservationMemNo:contractNo,
                golfCourseId:facilityId,
                playDateFrom:from,
                playDateTo:to
            }
            console.log(obj);
            common.doPost(golfReserveChk, obj, afterSearch);
        }
        
        //正常処理
        // afterSearch(resDate);
    }

    const afterSearch = (res) => {
        setErrorMessage("");
        //エラー時の処理
        if(res.data.resultCode !== "0"){
            setErrorMessage("検索に失敗しました。");
            setGolfReservationList([]);
            setReserveSearchInfo([]);
            return;
        }else if(res.data.reservationList === undefined || res.data.reservationList.length === 0){
            setErrorMessage("予約が見つかりませんでした。");
            setGolfReservationList([]);
            setReserveSearchInfo([]);
            return;
        }

        //検索リスト詰め込み
        let sortData = resevationSort(res.data)
        setSearchDate(sortData);
        //表示用
        setReserveSearchInfo(sortData.reservationList);
        //redux
        setGolfReservationList(sortData.reservationList);
    }

    const onClickDetail = (idx) => {
        let targetReserve = reserveSearchInfo[idx];
        console.log(targetReserve);
        setGolfReservationCheck(targetReserve);
        history.push("/reserve/golf/reservationCheckDetail");
    }

    const startTimeCourseNum = (courseName,time,teetimeLength) => {
        if(teetimeLength > 1){
            return courseName + " " + timeForm(time) + "...他、" + teetimeLength + "組"
        }else{
            return courseName + " " + timeForm(time) + "、" + teetimeLength + "組"
        }
    }

    //予約取得データのソート処理
    const resevationSort = (reserveData) => {
        if(reserveData.reservationList.length > 1){
            let selectDate = "";
            golfReservationSearch.search.map((value) => {
                    if(value.selected){
                        selectDate = value.valueYear;
                    }
            })
            //予約中なら昇順そうでなければ昇順
            if(selectDate === "ご予約中"){
                reserveData.reservationList.sort((a, b) => commonUtil.getDateFromString(a.date,"-") - commonUtil.getDateFromString(b.date,"-"));
            }else{
                reserveData.reservationList.sort((a, b) => commonUtil.getDateFromString(b.date,"-") - commonUtil.getDateFromString(a.date,"-"));
            }
        }
        return reserveData;
    }

    const timeForm = (timeInfo) => {
        let time = "";
        if (timeInfo.substr(0, 1) === '0') {
            time = timeInfo.substr(1, 1);
        } else {
            time = timeInfo.substr(0, 2);
        }
        time = time + "時";

        if (timeInfo.substr(3, 1) === '0') {
            time = time + timeInfo.substr(4, 1);
        } else {
            time = time + timeInfo.substr(3, 2);
        }
        time = time + "分";
        return time;
    }


    return (
        <>
            <div style={isWideTablet ? styles.breadCrumb2 : styles.breadCrumb}>
                <Link to={"/reserve/top"} style={styles.pan} >HOME</Link>
                <Label label=">" style={styles.breadCrumbArrow} />
                <Label label="予約確認" style={styles.pan} />
            </div>
            <div className="userInputInnerWrapper">
                <div style={isWideTablet ? styles.breadCrumb2 : { display: "none" }}></div>
                <div className={isMobilePhone ? "reservationAreaSp" : "reservationArea"}>
                    <div className={isMobilePhone ? null : "reservationContentArea"}>
                        <div className={errorMessage !== "" ? "reservationChkErrorMassage" : "reservationChkNone"} >{errorMessage}</div>
                        <div style={{marginBottom:"25px"}}>
                            <PullDownOptionForm
                                divClass={isMobilePhone ? "reservationSearchContentAreaSp" : "reservationSearchContentArea"}
                                title={"会員権選択"}
                                selectClass={"pullDownOptionKaiinkenStyle"}
                                data={kaiinken}
                                // state={kaiinkenNumber}
                                onChange={onChangeKaiinkenName} />
                            <PullDownOptionForm
                                id={"reservationSearchPullDown"}
                                divClass={isMobilePhone ? "reservationSearchContentAreaSp" : "reservationSearchContentArea"}
                                title={"対象期間"}
                                selectClass={"pullDownOptionKaiinkenStyle"}
                                data={golfReservationSearch.search}
                                onChange={changeTargetDate} />
                            <div className={isMobilePhone ? "reservationSearchBtnAreaSp" : "reservationSearchBtnArea"}>
                                <Button buttonText="検 索" className={isMobilePhone ? "reservationSearchBtnSp" : "reservationSearchBtn"} onClick={onClickSearch}/>
                            </div>
                        </div>
                        {golfReservationList !== undefined && golfReservationList.length !== 0 ?
                        <PullDownOptionForm
                            id={"selectDate"}
                            divClass={isMobilePhone ? "reservationSearchContentAreaSp" : "reservationSearchContentArea"}
                            title={"期間絞り込み"}
                            selectClass={"pullDownOptionKaiinkenStyle"}
                            data={golfReservationSearch.target}
                            // state={golfReservationSearch.target[0]}
                            onChange={changeSearchDate} />
                            :
                            null
                        }
                        <div className="reservationComfArea">
                            {reserveSearchInfo.length !== 0 ? reserveSearchInfo.map((data,index) => (
                                <div style={{padding:"20px 0px 20px 0px"}} key={index}>
                                    <div>
                                        <Label label={"ゴルフ場"} className={"reservationChkLabelTitle"}/>
                                        <Label label={data.golfCourseName} className={"reservationChkBody"} />
                                    </div>
                                    <div>
                                        <Label label={"プレー日"} className={"reservationChkLabelTitle"}/>
                                        <Label label={commonUtil.getStringFromDateJpnMembership(data.date)} className={"reservationChkBody"} />
                                    </div>
                                    <div>
                                        <Label label={"時間、組数"} className={"reservationChkLabelTitle"}/>
                                        <Label label={startTimeCourseNum(data.teeTimeList[0].courseName,data.teeTimeList[0].startTime,data.teeTimeList.length)} className={"reservationChkBody"}/>
                                    </div>
                                    <div className={"reservationChkBtnArea"}>
                                        <Button
                                            buttonText="予約内容を確認"
                                            className={isMobilePhone ? "reservationChkBtnSp" : "reservationChkBtn"}
                                            onClick={() => onClickDetail(index)}
                                        />
                                    </div>
                                </div>
                            )) : null}
                        </div>
                    </div>
                </div>
            </div>
            <div className="reservationChkFooter">
                <GolfFooterContainer />
            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        kaiinken:state.kaiinken,
        golfReservationCheck:state.golfReservationCheck,
        golfReservationSearch:state.golfReservationSearch,
        golfReservationList:state.golfReservationList,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setKaiinken: (item) => {
            dispatch({ type: "KAIINKEN", payload: {kaiinken:item} })
        },
        setGolfReservationCheck: (item) => {
            dispatch({ type: "GOLF_RESERVATION_CEHCK", payload: {golfReservationCheck:item} })
        },
        setGolfReservationSearch: (item) => {
            dispatch({ type: "GOLF_RESERVATION_SEARCH", payload: {golfReservationSearch:item} })
        },
        setGolfReservationList: (item) => {
            dispatch({ type: "GOLF_RESERVATION_LIST", payload: {golfReservationList:item} })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(GolfReservationCheckContainer);


const styles = {
    breadCrumbArrow: {
        marginRight: "5px",
        marginLeft: "5px",
        marginTop: "1px",
        fontSize: "small",
    },
    pan: {
        display: "inline-block",
        padding: "3px",
        color: "white",
        fontSize: "small",
    },
    footer: {
        width: "80%",
        padding: "30px 10% 10px 10%",
        whiteSpace: "nowrap",
        color: "white",
    },
    breadCrumb: {
        display: "flex",
        color: "white",
        paddingLeft: "15%",
        marginBottom: "50px",
        width: "100%",
        paddingTop: "50px",
        boxSizing:"border-box"
    },
    breadCrumb2: {
        visibility: "hidden",
        height: "10px"
    }
}
